import React, { useReducer } from "react";
import BillingAddressContext from "./BillingAddressContext";
import BillingAddressReducer from "./BillingAddressReducer";
import MethodGet, { MethodPost, MethodPut } from "../../Config/Services";
import Swal from "sweetalert2";
import { GET_ALL_BILLING, ADD_BILLING, UPDATE_BILLING } from "../../types";

const BillingAddressState = ({ children }) => {
  // Estado inicial
  const initialState = {
    billingAddress: [],
    billingAddres: null,
    ErrorsApi: [],
    success: false,
  };

  // Dispatch que ejecuta las funciones
  const [state, dispatch] = useReducer(BillingAddressReducer, initialState);

  // Funcion GET
  const GetBillingAddresses = () => {
    let url = "/billing-addresses";
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_BILLING,
          payload: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Funcion ALTA
  const AddBillingAddresses = (data) => {
    let url = "/billing-addresses";
    MethodPost(url, data)
      .then((res) => {
        dispatch({
          type: ADD_BILLING,
          payload: res.data,
        });
        Swal.fire({
          title: "¡Listo!",
          text: "Dirección de Facturación Agregada Correctamente",
          icon: "success",
        }).then(() => {
          window.location.href = "/DirecciónesFacturación";
        });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          if (responseData.error) {
            let errorMessages = "";
            for (const field in responseData.error) {
              if (responseData.error.hasOwnProperty(field)) {
                errorMessages += `${field}: ${responseData.error[field].join(
                  ", "
                )}\n`;
              }
            }
            Swal.fire({
              title: "Datos Incompletos",
              icon: "warning",
              text: errorMessages,
            });
          } else if (responseData.message) {
            Swal.fire({
              title: "Error",
              icon: "error",
              text: responseData.message,
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            icon: "error",
            text: "Ocurrió un error inesperado.",
          });
        }
      });
  };

  // Funcion EDITAR
  const EditBillingAddresses = (data) => {
    let url = "/billing-addresses/" + data.id;
    MethodPut(url, data)
      .then((res) => {
        dispatch({
          type: UPDATE_BILLING,
          payload: res.data,
        });
        Swal.fire({
          title: "¡Listo!",
          text: "Direccion de Facturación Editada Correctamente",
          icon: "success",
        }).then(() => {
          window.location.href = "/DirecciónesFacturación";
        });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          if (responseData.error) {
            let errorMessages = "";
            for (const field in responseData.error) {
              if (responseData.error.hasOwnProperty(field)) {
                errorMessages += `${field}: ${responseData.error[field].join(
                  ", "
                )}\n`;
              }
            }
            Swal.fire({
              title: "Datos Incompletos",
              icon: "warning",
              text: errorMessages,
            });
          } else if (responseData.message) {
            Swal.fire({
              title: "Error",
              icon: "error",
              text: responseData.message,
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            icon: "error",
            text: "Ocurrió un error inesperado.",
          });
        }
      });
  };

  return (
    <BillingAddressContext.Provider
      value={{
        billingAddress: state.billingAddress,
        billingAddres: state.billingAddres,
        ErrorsApi: state.ErrorsApi,
        success: state.success,
        GetBillingAddresses,
        AddBillingAddresses,
        EditBillingAddresses,
      }}
    >
      {children}
    </BillingAddressContext.Provider>
  );
};

export default BillingAddressState;
